<script setup lang="ts">
const props = defineProps<{
  faqArray: Array<{
    answer: string
    question: string
    _key: string
  }>
}>()

const openKey = ref(props.faqArray?.[0]?._key)
const isKeyOpen = (key: string) => openKey.value === key
</script>

<template>
  <section class="flex flex-col">
    <div
      v-for="faq in faqArray"
      class="shadow-faq rounded-2xl px-10 py-7.5 transition-all transition-200 cursor-pointer"
      :class="isKeyOpen(faq._key) ? 'my-5' : 'my-2.5'"
      @click="openKey = faq._key"
    >
      <div class="font-semibold h4 text-gray-700 font-alt">
        {{ faq.question }}
      </div>
      <collapse-transition :duration="200">
        <div v-show="isKeyOpen(faq._key)">
          <p class="text-gray-250 py-2.5 !mt-0 !mb-0 font-[16px]">
            {{ faq.answer }}
          </p>
        </div>
      </collapse-transition>
    </div>
  </section>
</template>
